/*
 * GRAMORPH custom analytics events (site review 2026-09-28 #3-26).
 * Publishes custom events to Shopify's Customer Events (Web Pixels) so a custom pixel can forward them to GA4.
 * - gramorph:variant_selected  … a metal (variant) was chosen on the product page
 * - gramorph:accordion_opened  … a collapsible tab (受注生産について etc.) was opened
 * - gramorph:share_clicked     … the share button was clicked
 * Does nothing when Shopify.analytics.publish is not available (e.g. theme editor, preview without pixels).
 * Setup of the receiving custom pixel: docs/MEASUREMENT.md
 */
(function () {
  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {
      /* never break the storefront for analytics */
    }
  }

  // Handle of the product an element belongs to: from the enclosing <product-info data-url>
  // (also works for featured-product sections), falling back to the page URL.
  function productHandle(element) {
    var productInfo = element && element.closest ? element.closest('product-info[data-url]') : null;
    var path = productInfo ? productInfo.dataset.url : window.location.pathname;
    var match = path && path.match(/\/products\/([^/?#]+)/);
    if (!match) return null;
    try {
      return decodeURIComponent(match[1]);
    } catch (e) {
      return match[1];
    }
  }

  // constants.js declares PUB_SUB_EVENTS with a top-level const, which is not a window property,
  // so check the binding itself.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      // Never let an error here stop the other variantChange subscribers.
      try {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;
        var sectionId = event.data.sectionId;
        var productInfo = sectionId ? document.querySelector('product-info[data-section="' + sectionId + '"]') : null;
        publish('gramorph:variant_selected', {
          product_handle: productHandle(productInfo),
          variant_id: variant.id,
          variant_title: variant.title,
          sku: variant.sku || null,
        });
      } catch (e) {
        /* ignore */
      }
    });
  }

  // "toggle" does not bubble, so listen in the capture phase.
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.open) return;
      if (!details.closest('.product__accordion')) return;
      var summary = details.querySelector('summary');
      publish('gramorph:accordion_opened', {
        product_handle: productHandle(details),
        heading: summary ? summary.textContent.replace(/\s+/g, ' ').trim() : null,
      });
    },
    true
  );

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var button = event.target.closest('share-button .share-button__button');
    if (!button) return;
    // Fallback (no Web Share API): the button is a <summary>. Count only the click that opens it, not the one that closes it.
    if (button.tagName === 'SUMMARY' && button.parentElement && button.parentElement.open) return;
    publish('gramorph:share_clicked', { product_handle: productHandle(button) });
  });
})();
